import React from 'react';

const STICKY_STYLE = { position: 'sticky', top: 0, zIndex: 10 };
const STICKY_STYLE_WHITE = { position: 'sticky', top: 0, zIndex: 10, backgroundColor: 'white' };
const W2 = { width: '2rem' };
const W4 = { width: '4rem' };
const W5 = { width: '5rem' };
const W6 = { width: '6rem' };
const W7 = { width: '7rem' };
const W8 = { width: '8rem' };
const W10 = { width: '10rem' };
const W12 = { width: '12rem' };
const W14 = { width: '14rem' };
const W15 = { width: '15rem' };
const W3 = { width: '3rem' };

const DashboardHeader = React.memo(({ expanded }) => {

  const defautTask = (c, size) => {
    return (<>
        <th colSpan={c} className={"small"} style={size}>설계</th>
        <th colSpan={c} className={"small"} style={size}>P/G</th>
        <th colSpan={c} className={"small"} style={size}>제조1</th>
        <th colSpan={c} className={"small"} style={size}>제조2</th>
        <th colSpan={c} className={"small"} style={size}>제조3</th>
        <th colSpan={c} className={"small"} style={size}>출하</th>
        <th colSpan={c} className={"small"} style={size}>QC </th>
        <th colSpan={c} className={"small"} style={size}>AS </th>
    </>)
  }

  const theadCollapsed = () => {
    return (<thead className='table-primary' style={STICKY_STYLE}>
      <tr>
        <th colSpan={4}>고객정보</th>
        <th colSpan={2}>상품정보</th>
        <th colSpan={3}>규격정보</th>
        <th colSpan={1}>납기정보</th>
        <th colSpan={6}>제조공정사항</th>
        <th colSpan={2} style={W7}>제조관리사항</th>
      </tr>
      <tr>
        <th style={W2}>ID</th>
        <th style={W12}>수주번호</th>
        <th style={W10}>거래처</th>
        <th style={W10}>프로젝트명</th>
        <th style={W8}>구분</th>
        <th style={W6}>수량</th>
        <th style={W4}>W</th>
        <th style={W4}>H</th>
        <th style={W4}>D</th>
        <th style={W6}>납기일</th>
        { defautTask(1, W3) }
      </tr>
    </thead>
    );
  }

  const theadExpanded = () => {
    return (<thead className='table-primary' style={STICKY_STYLE_WHITE}>
      <tr>
        <th colSpan={6}>고객정보</th>
        <th>매출정보</th>
        <th colSpan={4}>도장정보</th>
        <th colSpan={3}>상품정보</th>
        <th colSpan={3}>규격정보</th>
        <th colSpan={2}>납기정보</th>
        <th colSpan={36}>제조공정사항</th>
        <th colSpan={14}>제조관리사항</th>
      </tr>
      <tr>
        <th rowSpan={2} style={W2}>ID</th>
        <th rowSpan={2} style={W8}>접수일</th>
        <th rowSpan={2} style={W14}>수주번호</th>
        <th rowSpan={2} style={W10}>거래처</th>
        <th rowSpan={2} style={W10}>프로젝트명</th>
        <th rowSpan={2} style={W5}>총수량</th>
        <th rowSpan={2} style={W6}>예상매출액</th>
        <th rowSpan={2} style={W6}>도장색상</th>
        <th rowSpan={2} style={W6}>도장두께</th>
        <th rowSpan={2} style={W6}>내진</th>
        <th rowSpan={2} style={W6}>기타</th>

        <th rowSpan={2} style={W8}>구분</th>
        <th rowSpan={2} style={W6}>수량</th>
        <th rowSpan={2} style={W6}>등분</th>
        <th rowSpan={2} style={W4}>W</th>
        <th rowSpan={2} style={W4}>H</th>
        <th rowSpan={2} style={W4}>D</th>
        <th rowSpan={2} style={W6}>납기일</th>
        <th rowSpan={2} style={W6}>납품장소</th>

        {defautTask(6, W6)}
      </tr>
      <tr>
        {Array.from({ length: 8 }).map((_, index) => (
          <React.Fragment key={index}>
            <th className="small" style={W6}>시작일</th>
            <th className="small" style={W6}>종료일</th>
            <th className="small" style={W6}>담당자</th>
            <th className="small" style={W15}>작업시작</th>
            <th className="small" style={W15}>작업종료</th>
            <th className="small" style={W10}>비고</th>
          </React.Fragment>
        ))}
      </tr>
    </thead>
    );
  }

  return (
    expanded === true ? theadExpanded() : theadCollapsed()
  );
});

export default DashboardHeader;
